<template>
  <div style="min-width:750px;height:calc(100% - 20px);display:flex;flex-direction:column;" class="ml-10 mr-5 mt-5">
    <div style="display:flex;" class="pr-5">
      <v-tabs v-model="topBarIndex" class="mainNoticeTopTabs">
        <v-tab :style="{'color':topBarIndex === 0 ? '#1976D2' : '#000000'}" style="font-size:20px;" class="px-0 mr-5">公告</v-tab>
        <v-tab :style="{'color':topBarIndex === 1 ? '#1976D2' : '#000000'}" style="font-size:20px;" class="px-0 mr-5">账户通知</v-tab>
        <v-tabs-slider color="#1976D2"></v-tabs-slider>
      </v-tabs>
    </div>
    <div style="background:#ffffff;" class="px-10 py-10 my-4">
      <!--公告-->
      <div v-if="topBarIndex === 0">
        <div @click="clickSystemNotice(item,index)" v-for="(item,index) in systemNoticeList" :key="'systemNotice'+index"
             :style="{'border-top':index === 0 ? '1px solid #e5e5e5' : 'none'}" class="systemNoticeItem px-6">
          <div :style="{'background':item.isRead ? '#e5e5e5' : '#1976D2'}" style="width:8px;height:8px;border-radius:50%;flex:none;" class="mr-4"></div>
          {{item.title}}
          <v-spacer></v-spacer>
          {{item.gmtCreatetime}}
        </div>
      </div>

      <!--账户通知-->
      <v-expansion-panels v-if="topBarIndex === 1" accordion flat>
        <v-expansion-panel @click="clickUserNotice(item,index)" v-for="(item,index) in userNoticeList" :key="'userNotice'+index"
                           :style="{'border-top':index === 0 ? '1px solid #e5e5e5' : 'none'}"
                           style="border-bottom:1px solid #e5e5e5;">
          <v-expansion-panel-header>
            <div :style="{'background':item.isRead ? '#e5e5e5' : '#1976D2'}" style="width:8px;height:8px;border-radius:50%;flex:none;" class="mr-4"></div>
            {{item.title}}
            <v-spacer></v-spacer>
            {{item.gmtCreatetime}}
            <template v-slot:actions>
              <v-icon>mdi-menu-down</v-icon>
            </template>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <p v-html="item.content"></p>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>



    </div>

    <v-spacer></v-spacer>

    <!--页码-->
    <page-number v-if="totalPageNum > 1" :totalPageNum="totalPageNum" :currPageNum="currPageNum" @changePageNumber="changePageNumber" class="mb-5"></page-number>

  </div>

</template>

<script>
import PageNumber from '/src/components/page_number/PageNumber';
export default {
  name: "MainNotice",
  components: {
    PageNumber
  },
  data(){
    return{
      topBarList:[
        {title:"公告",value:1},
        {title:"账户通知",value:0},
      ],
      topBarIndex:0,

      //系统公告
      systemNoticeList:[],

      //账户通知
      userNoticeList:[],


      //页码
      totalPageNum:0,
      currPageNum:1


    }

  },
  watch:{
    topBarIndex(){
      this.getNoticeList(this.topBarList[this.topBarIndex].value,1)
    }
  },
  methods:{

    getNoticeList(type,pageNum){
      this.totalPageNum = 0;
      this.$axios({
        method:"get",
        url:"/authorApi/notice/getNoticeList",
        params:{
          system:type,
          curPageNum:pageNum,
          maxResultNum:20,
        }
      }).then((resultData)=>{
        resultData = resultData.data;
        if(resultData.status === 200){
          if(type === 0){
            //账户通知
            this.userNoticeList = resultData.data.noticeList;
            for(let i=0;i<this.userNoticeList.length;i++){
              if(this.userNoticeList[i].content.indexOf("《吉林一号·共生地球创作中心创作规范》") !== -1){
                this.userNoticeList[i].content = this.userNoticeList[i].content.replace("《吉林一号·共生地球创作中心创作规范》","<a style='text-decoration:none;' target='_blank' href='" + document.location.origin + "/" + document.location.pathname.split("/")[1] + "/documentPage?pageType=createAgreement'>《吉林一号·共生地球创作中心创作规范》</a>")
              }
            }
          }
          else if(type === 1){
            //公告
            this.systemNoticeList = resultData.data.noticeList;
          }
          this.currPageNum = pageNum;
          this.totalPageNum = resultData.data.totalPageNum;
        }
        else{
          console.log(resultData.status + resultData.message);
        }
      }).catch((err)=>{
        console.log(err);
      });

    },
    // //获取已读标识
    // getReadStatus(type,id){
    //   if(type === "system"){
    //     //公告
    //     if(localStorage.getItem('systemNoticeReadStatus') !== null){
    //       let hasReadIdList = JSON.parse(localStorage.getItem('systemNoticeReadStatus'));
    //       if(hasReadIdList.indexOf(id) !== -1){
    //         //该内容已读
    //         return true;
    //       }
    //       else{
    //         //该内容未读
    //         return false;
    //       }
    //     }
    //     else{
    //       //全部未读
    //       return false;
    //     }
    //
    //   }
    //   else if(type === "user"){
    //     //账户通知
    //     if(localStorage.getItem('userNoticeReadStatus') !== null){
    //       let hasReadIdList = JSON.parse(localStorage.getItem('userNoticeReadStatus'));
    //       if(hasReadIdList.indexOf(id) !== -1){
    //         //该内容已读
    //         return true;
    //       }
    //       else{
    //         //该内容未读
    //         return false;
    //       }
    //     }
    //     else{
    //       //全部未读
    //       return false;
    //     }
    //
    //   }
    // },


    //修改页码
    changePageNumber(param){
      this.getNoticeList(this.topBarList[this.topBarIndex].value,param)
    },



    //点击公告
    clickSystemNotice(item,index){
      let route = this.$router.resolve({
        path: "/systemNoticePage",
        query: {
          noticeId:item.id
        }
      });
      window.open(route.href, '_blank');
      if(!item.isRead){
        //未读
        this.systemNoticeList[index].isRead = true;
        //存储已读状态
        this.$axios({
          method:"get",
          url:"/authorApi/notice/getNoticeById",
          params:{
            noticeId:item.id,
            system:0
          }
        }).then((resultData)=>{
          resultData = resultData.data;
          if(resultData.status === 200){
            this.getNewNoticeStatus();
          }
          else{
            console.log(resultData.status + resultData.message);
          }
        }).catch((err)=>{
          console.log(err);
        });

      }
    },
    //点击账户通知
    clickUserNotice(item,index){
      if(!item.isRead){
        //未读
        this.userNoticeList[index].isRead = true;
        //存储已读状态
        this.$axios({
          method:"get",
          url:"/authorApi/notice/getNoticeById",
          params:{
            noticeId:item.id,
            system:0
          }
        }).then((resultData)=>{
          resultData = resultData.data;
          if(resultData.status === 200){
            this.getNewNoticeStatus();

          }
          else{
            console.log(resultData.status + resultData.message);
          }
        }).catch((err)=>{
          console.log(err);
        });
      }
    },


    //获取消息中心状态，红点是否隐藏
    getNewNoticeStatus(){
      this.$axios({
        method:"get",
        url:"/authorApi/notice/exitNotReadNotice",
      }).then((resultData)=>{
        resultData = resultData.data;
        if(resultData.status === 200){
          if(!resultData.data){
            this.$store.state.newNotice = resultData.data
          }
        }
        else{
          console.log(resultData.status + resultData.message);
        }
      }).catch((err)=>{
        console.log(err);
      });
    },



  },
  mounted(){
    this.getNoticeList(1,1);
  }

}
</script>

<style scoped>
.systemNoticeItem{
  height:48px;
  border-bottom:1px solid #e5e5e5;
  display:flex;
  align-items: center;
  cursor:pointer;
}
.systemNoticeItem:hover{
  background:rgba(30, 58, 138, 0.05);
}

</style>

<style>
.mainNoticeTopTabs .v-tabs-bar{
  background:transparent !important;
}

</style>